import { config } from 'maplibre-gl'
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'

/**
 * Pins maplibre-gl's worker to an asset Vite actually emits.
 *
 * maplibre-gl v6 is ESM-only and resolves its worker at runtime with
 * ``new URL(`./${name}`, import.meta.url)``. That template literal is invisible to
 * Rollup's static analysis, so Vite never emits the worker file and the request
 * 404s. The worker then dies *without firing an `error` event*: tiles are still
 * fetched, but nothing parses them, and the map paints an empty background. There
 * is no console output at all — which is how a fully green CI run still produced a
 * blank map in staging.
 *
 * `?worker&url` makes Vite bundle the worker — resolving its own
 * `maplibre-gl-shared` import, which a plain `?url` copy would leave dangling —
 * and hand back the hashed asset URL. `config.WORKER_URL` is maplibre's documented
 * override and takes precedence over the computed path.
 *
 * This lives in the app rather than next to the map component in `packages/ui`
 * because `?worker&url` is Vite-specific and `packages/ui` is also consumed by
 * Metro for the native app, where that import does not resolve.
 */
config.WORKER_URL = workerUrl
